/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="95.58"
        height="70.67"
        viewBox="0 0 95.58 70.67"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M56.33 28.9a1.25 1.25 0 0 1 1.24 1.12v25.66a1.28 1.28 0 0 1-1.07 1.25H28.27a1.26 1.26 0 0 1-1.29-1.1v-25a1.25 1.25 0 0 1 2.48-.14v23.74h25.62V30.15a1.23 1.23 0 0 1 1.12-1.24Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M69.59 44.33a1.26 1.26 0 0 1 1.25 1.17v10.18a1.26 1.26 0 0 1-1.12 1.25H41.5a1.27 1.27 0 0 1-1.23-1.28 1.25 1.25 0 0 1 1.1-1.21h27v-8.86a1.24 1.24 0 0 1 1.16-1.24ZM41.73 21.6a1.21 1.21 0 0 1 1-.07l.14.06 21.2 10.38a1.254 1.254 0 0 1-1 2.3h-.09L42.34 24.11l-19.9 10.1a1.26 1.26 0 0 1-1.61-.43l-.07-.12a1.23 1.23 0 0 1 .43-1.61l.12-.07Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M55.21 37.73a1.23 1.23 0 0 1 1.55-.62h.12l17.36 8.49a1.254 1.254 0 0 1-1 2.3h-.12l-17.34-8.5a1.24 1.24 0 0 1-.58-1.66Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="M86.74 0a8.84 8.84 0 0 1 8.84 8.58v53.25A8.84 8.84 0 0 1 87 70.67H8.84A8.84 8.84 0 0 1 0 62.09V8.83A8.85 8.85 0 0 1 11.42.37a1.27 1.27 0 0 1 .88 1.12v53.07a1.27 1.27 0 0 1-1.27 1.25 1.34 1.34 0 0 1-.35-.05 5.78 5.78 0 0 0-1.84-.27 6.341 6.341 0 1 0-.23 12.68h78.13a6.34 6.34 0 1 0 0-12.68 5.81 5.81 0 0 0-1.85.28 1.28 1.28 0 0 1-1.57-.85 1 1 0 0 1 0-.23V1.58a1.25 1.25 0 0 1 .88-1.2A9 9 0 0 1 86.74 0ZM8.84 2.5A6.35 6.35 0 0 0 2.5 8.61v47.06l.09-.09a8.74 8.74 0 0 1 6-2.58h1.23V2.57l-.62-.06Zm77.9 0h-1v50.55h1a8.8 8.8 0 0 1 6.25 2.59l.09.09V8.83a6.34 6.34 0 0 0-6.11-6.34Z"
          className="icon-fill icon-base"/><path
          fill="#fff"
          d="M84.53 9.18v2.5H11.06v-2.5h73.47zM48.64 35.07H35.98v12.69h12.69Zm-2.5 2.5v7.69H38.5v-7.69Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'BlueprintWithHouseIcon';

export default Icon;
